import React from 'react';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import '@mui/x-date-pickers/themeAugmentation'; // For default theme extension
import dayjs from "dayjs";

const eventDates = [
  dayjs("2025-05-22"),
  dayjs("2025-05-28"),
  dayjs("2025-06-05"),
];

function MyCalendar() {
  const renderDay = (day, selectedDates, pickersDayProps) => {
    const hasEvent = eventDates.some(eventDate => day.isSame(eventDate, 'day'));

    return (
      <div style={{ position: 'relative' }}>
        {pickersDayProps.children}
        {hasEvent && (
          <div
            style={{
              position: 'absolute',
              bottom: 2,
              left: '50%',
              transform: 'translateX(-50%)',
              width: 6,
              height: 6,
              borderRadius: '50%',
              backgroundColor: 'primary.main',
            }}
          />
        )}
      </div>
    );
  };

  return (
    <LocalizationProvider dateAdapter={AdapterMoment}>
      <DatePicker renderDay={renderDay} />
    </LocalizationProvider>
  );
}

export default MyCalendar;